var _rect, _rect2, _path, _circle, _path2, _circle2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValidator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 671,
    height: 568,
    viewBox: "0 0 671 568",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.706,
    y: 372.843,
    width: 72.867,
    height: 56.069,
    rx: 28.035,
    transform: "rotate(-30 28.706 372.843)",
    fill: "#E6E6E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 481.589,
    y: 46.625,
    width: 56.131,
    height: 56.131,
    rx: 28.066,
    transform: "rotate(-30 481.589 46.625)",
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.695 207.074c-13.424 7.75-18.023 24.915-10.273 38.338 7.636 13.226 24.411 17.886 37.743 10.607l40.611-23.446c13.423-7.75 30.588-3.151 38.338 10.272 7.75 13.424 3.151 30.589-10.273 38.339l-73.088 42.198c.158-.088.316-.177.474-.268l255.075-147.268c.161-.093.321-.187.48-.283l-13.468 7.776c-13.424 7.75-30.589 3.151-38.339-10.273s-3.151-30.588 10.273-38.338l11.88-6.86c12.963-7.908 17.311-24.761 9.677-37.984-7.75-13.424-24.915-18.023-38.338-10.273L203.695 207.074zm137.134 180.085c-13.423 7.751-18.023 24.915-10.272 38.339 7.75 13.423 24.914 18.023 38.338 10.273l156.48-90.344c13.424-7.751 18.023-24.915 10.273-38.339-7.75-13.423-24.915-18.023-38.338-10.273l-156.481 90.344zm-57.825 33.376l.347-.197L493.07 299.256c.129-.074.257-.149.384-.225l-5.206 3.005c-13.423 7.75-30.588 3.151-38.338-10.272-7.75-13.424-3.151-30.589 10.273-38.339l67.134-38.76c.175-.101.351-.2.528-.297l23.298-13.451c13.423-7.75 18.022-24.915 10.272-38.339-7.75-13.423-24.914-18.022-38.338-10.272L177.326 351.925c-13.424 7.75-18.023 24.915-10.273 38.338 7.655 13.258 24.492 17.908 37.839 10.555l88.063-50.843c13.424-7.75 30.589-3.151 38.339 10.272 7.75 13.424 3.151 30.589-10.273 38.339l-38.017 21.949z",
    fill: "#E6E6E6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 607.099,
    cy: 398.512,
    r: 14.562,
    stroke: "#E6E6E6",
    strokeWidth: 7.009
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.488 124.329c0 5.978-4.846 10.824-10.824 10.824s-10.824-4.846-10.824-10.824 4.846-10.824 10.824-10.824 10.824 4.846 10.824 10.824z",
    stroke: "#E6E6E6",
    strokeWidth: 7.009
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.63,
    cy: 493.341,
    r: 16.6,
    stroke: "#E6E6E6",
    strokeWidth: 7.009
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 398.53,
    y: 14.33,
    width: 34.887,
    height: 6.23,
    rx: 3.115,
    fill: "#E6E6E6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 419.091,
    width: 34.887,
    height: 6.23,
    rx: 3.115,
    transform: "rotate(90 419.091 0)",
    fill: "#E6E6E6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 512.97,
    y: 488.73,
    width: 26.166,
    height: 6.23,
    rx: 3.115,
    fill: "#E6E6E6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 529.169,
    y: 479.077,
    width: 26.166,
    height: 6.23,
    rx: 3.115,
    transform: "rotate(90 529.169 479.077)",
    fill: "#E6E6E6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 121.668,
    y: 262.654,
    width: 26.166,
    height: 6.23,
    rx: 3.115,
    fill: "#E6E6E6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 137.867,
    y: 253,
    width: 26.166,
    height: 6.23,
    rx: 3.115,
    transform: "rotate(90 137.867 253)",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M461.095 201.676c-12.957 10.376-31.922 9.559-43.933-2.451-12.01-12.011-12.827-30.976-2.451-43.933l-41.625-41.625-207.418 207.418 41.625 41.625c12.957-10.38 31.925-9.564 43.937 2.447 12.012 12.012 12.828 30.98 2.448 43.937l41.626 41.627 207.418-207.418-41.627-41.627z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M461.095 201.677c-12.957 10.377-31.923 9.561-43.934-2.45s-12.828-30.977-2.45-43.934l-41.626-41.626-38.957 38.519.001 172.333v64.167l-.002 23.833 168.594-169.216-41.626-41.626z",
    fill: "#ECECEC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M253.635 409.052l41.669 41.669 207.418-207.418-41.669-41.669M207.337 362.753l-41.669-41.668 207.418-207.418 41.669 41.668",
    stroke: "#AFAFAF",
    strokeWidth: 7.333
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M463.834 199.226c-12.888 12.887-33.782 12.887-46.669 0-12.888-12.887-12.888-33.782 0-46.669M204.558 365.161c12.887-12.887 33.781-12.887 46.669 0 12.887 12.888 12.887 33.782 0 46.669M308.268 178.485l23.334 23.335M347.162 217.375l18.921 18.922M383.456 253.673l18.921 18.922M438.219 308.44l-23.652-23.651",
    stroke: "#AFAFAF",
    strokeWidth: 7.333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidator);
export default __webpack_public_path__ + "static/media/validator.71ac74da.svg";
export { ForwardRef as ReactComponent };